import { JSX, ReactNode } from "react";
import { formatDate, LoadingSpinner } from "@app/shared";

interface WidgetProps {
    title: string;
    asOfDate: Date;
    children?: ReactNode;
}

const Widget = (props: WidgetProps): JSX.Element => {
    const { title, asOfDate, children } = props;

    return (
    <div className='col-12 col-sm-6 col-lg-4 col-xl-3 col-xxl-2dot4 col-xxxl-2 col-4xl-1dot7 col-5xl-1dot5 col-6xl-1dot33'>
        <div className='tile-item ellipsis'>
            <div className='box-style-1 white-bg project-tile-top'>
                <div className="d-flex flex-column align-items-start mt-3 ml-3">
                    <h3 className='lead font-weight-bold mtb0'>{title}</h3>
                    <div className="hgt47">
                        <p className="color-logan">
                            As of {formatDate(asOfDate)}
                        </p>
                    </div>
                </div>
              {children || <h5 className="ml-3 mb-3 text-muted text-wrap">Unable to Load Widget</h5>}
            </div>
        </div>
    </div>
    );
}

const WidgetLoading = (): JSX.Element => {
    return (
    <span className='skeleton shimmer'>
        <div className='col-12 col-sm-6 col-lg-4 col-xl-3 col-xxl-2dot4 col-xxxl-2 col-4xl-1dot7 col-5xl-1dot5 col-6xl-1dot33'>
            <div className='tile-item ellipsis'>
                <div className='box-style-1 white-bg project-tile-top'>
                    <div className="d-flex flex-column align-items-start ml-3 mt-3 mb-3">
                        <LoadingSpinner/>
                    </div>
                </div>
            </div>
        </div>
    </span>
    );
}


export { Widget, WidgetLoading };